import * as types from './types';

export default {
  setUserSettings: (payload) => ({ type: types.GET_USER_SETTINGS, payload }),
};
